// Fiscal year runs Nov 1 – Oct 31 (Eastern). FY2027 = Nov 1 2026 – Oct 31 2027; numbers are prefixed "27-".
const eastern = (d = new Date()) => new Date(d.toLocaleString('en-US', { timeZone: 'America/Toronto' }));

export const fiscalYear = (d = new Date()) => {
  const e = eastern(d);
  const y = e.getMonth() >= 10 ? e.getFullYear() + 1 : e.getFullYear();
  return { long: String(y), short: String(y).slice(-2), start: new Date(y - 1, 10, 1), end: new Date(y, 9, 31) };
};

// Evaluated on every read, so a tab left open across midnight Oct 31 flips without a reload.
export const FY = {
  get long() { return fiscalYear().long; },
  get short() { return fiscalYear().short; },
  get start() { return fiscalYear().start; },
  get end() { return fiscalYear().end; },
};
export const fyLabel = (short) => `FY${2000 + Number(short)}`;
